module.exports = __webpack_public_path__ + "static/media/bluetooth-b.034636cb.svg";